'use client';

import { useModal } from '@cat-ecom/pcc-components';
import { FC, PropsWithChildren, createContext, useContext } from 'react';
import { UserConsentLoaderProvider } from './user-consent-loader-context';

const UserConsentModalContext =
  createContext<ReturnType<typeof useModal>>(null);

export const useUserConsentModal = () => useContext(UserConsentModalContext);

export const UserConsentModalProvider: FC<PropsWithChildren> = ({
  children
}) => {
  const userConsentModal = useModal({
    initialActive: false,
    size: 'md'
  });

  return (
    <UserConsentLoaderProvider>
      <UserConsentModalContext.Provider value={userConsentModal}>
        {children}
      </UserConsentModalContext.Provider>
    </UserConsentLoaderProvider>
  );
};
